module.exports = __webpack_public_path__ + "static/media/comf.4efb4025.png";